module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col bg-white"
  }, [(_vm.courselist_loading) ? _c('div', {
    staticClass: "flex h-screen items-center justify-center"
  }, [_c('pl-spinner', {
    staticClass: "x3"
  })], 1) : _c('div', {
    staticClass: "flex-grow"
  }, [(_vm.getProfile.role === 'admin') ? _c('admin-dashboard', {
    staticClass: "container mx-auto h-full"
  }) : _c('div', [_c('default-layout', [_c('DashboardCards')], 1)], 1)], 1), _vm._v(" "), (_vm.show_new_premade_modal) ? _c('NewPremadeModal', {
    attrs: {
      "premadeId": _vm.premade_id,
      "premadeType": _vm.premade_type,
      "openAiTitle": _vm.open_ai_title,
      "openAiPrompt": _vm.open_ai_prompt
    },
    on: {
      "close": function($event) {
        _vm.show_new_premade_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_choose_activity_overlay) ? _c('FullScreenChooseActivity', {
    on: {
      "close": function($event) {
        _vm.show_choose_activity_overlay = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDraftOpen === true) ? _c('Draft', {
    attrs: {
      "id": _vm.selectedDraft.id,
      "type": _vm.selectedDraft.type
    },
    on: {
      "close": function($event) {
        _vm.isDraftOpen = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-fe32bffa!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/dashboard/dashboard.vue
// module id = 1642
// module chunks = 61